import { render, staticRenderFns } from "./ProfileSkillSimulation.vue?vue&type=template&id=57139b8c"
import script from "./ProfileSkillSimulation.vue?vue&type=script&lang=js"
export * from "./ProfileSkillSimulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports